import React, { useState } from 'react';

const BasicToolTip = ({ children, className, text }:{children:React.ReactNode, className?: string, text: string}) => {
    const [visible, setVisible] = useState(false);

    return (
        <span className={`basic-tooltip-wrapper ${className ?? ""}`} onMouseEnter={() => setVisible(true)}  onMouseLeave={() => setVisible(false)}>
            {children}

            {visible && (<span className="basic-tooltip">{text}</span>)}
        </span>
    );
};

export default BasicToolTip;